import * as React from "react";
import { Collapse } from "react-collapse";
import { Div } from "../../../components/core/03-base/Div";
import { Button } from "../../../components/core/05-atoms/Button";
import { Alignment, ButtonsWrapper, Orientation } from "../../../components/core/06-molecules/ButtonsWrapper";
import { Navbar } from "../../../components/core/07-organisms/Navbar";
import { NavbarStack, NavbarStackContent, NavbarStackRight } from "../../../components/core/07-organisms/Navbar/Stack";
import { NavbarTitle } from "../../../components/core/07-organisms/Navbar/Title";
import { ThemeBreakpoints, ThemePalette, ThemePaletteState, ThemeShadowSizes } from "../../../theme/_Types";
import * as I18n from "../../../utils/translations/I18n";
/**
 *
 * @param props
 */
export var WizardCard = function (props) {
    var _a;
    var _b;
    var toggleByIcon = function (evt) {
        if (props.id !== props.counter) {
            props.setActive(Number(evt.currentTarget.id));
        }
        if (Number(evt.currentTarget.id) === props.counter) {
            props.setActive(Number(evt.currentTarget.id) + 1);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Navbar, { theme: {
                palette: props.theme ? props.theme.palette : ThemePalette.CONTRAST_TERTIARY,
            }, className: "scl-h-text-align--left" },
            React.createElement(NavbarStack, null,
                React.createElement(NavbarStackContent, null,
                    React.createElement(NavbarTitle, null, props.title)),
                !!props.collapsable && React.createElement(NavbarStackRight, null,
                    React.createElement(Div, { theme: { padding: { "": { x: 2 }, "sm": { x: 3 } } } },
                        React.createElement("div", { style: {
                                transition: "transform .3s ease",
                                transform: props.id === props.counter
                                    ? "rotate(-90deg)" : "rotate(0deg)",
                            } },
                            React.createElement(Button, { link: {
                                    onClick: function (evt) { return toggleByIcon(evt); },
                                }, icon: "chevron-left", theme: { palette: ThemePalette.BRAND_ACCENT }, id: (_b = props.id) === null || _b === void 0 ? void 0 : _b.toString() })))))),
        React.createElement(Collapse, { isOpened: props.id === props.counter ? true : false },
            props.children || React.createElement(React.Fragment, null),
            React.createElement(Div, { theme: {
                    shadow: ThemeShadowSizes.TINY,
                    padding: {
                        "": { y: 1, x: 3 },
                        "sm": { y: 1, x: 3 },
                    },
                } },
                React.createElement(ButtonsWrapper, { orientations: (_a = {}, _a[ThemeBreakpoints.XS] = Orientation.HORIZONTAL, _a), alignment: Alignment.RIGHT },
                    props.id && props.id > 0 ? (React.createElement(Div, { style: { display: "flex" } },
                        React.createElement(Button, { theme: { palette: ThemePalette.CONTRAST_TERTIARY }, className: "scl-a-btn--huge scl-a-btn", link: { onClick: function () { return props.setActive(props.counter - 1); } } }, I18n.getText("mary.previous", "Previous")))) : React.createElement(React.Fragment, null),
                    React.createElement(Div, { style: { display: "flex" } },
                        React.createElement(Button, { theme: { paletteState: ThemePaletteState.SUCCESS }, className: "scl-a-btn--huge scl-a-btn", link: { onClick: function () { return props.setActive(props.counter + 1); } }, disabled: !props.isValid }, I18n.getText("mary.next", "Next"))))))));
};
